import axios from "axios";

const state = {
  user: localStorage.getItem("user"),
  token: localStorage.getItem("token"),
  refresh_token: null,
  roles: localStorage.getItem("roles"),
  permissions: localStorage.getItem("permissions"),
};

const actions = {
  login: (context, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: context.rootGetters.baseUrl + "auth/login",
        data: {
          token: payload.token,
        },
      })
        .then((response) => {
          const token = response.data.token;
          const user = JSON.stringify(response.data.data);
          const roles = JSON.stringify(response.data.roles);
          const permissions = JSON.stringify(response.data.permissions);

          localStorage.setItem("token", token);
          localStorage.setItem("user", user);
          localStorage.setItem("roles", roles);
          localStorage.setItem("permissions", permissions);

          axios.defaults.headers.Authorization = `Bearer ${token}`;

          context.commit("USER_UPDATE", user);
          context.commit("TOKEN_UPDATE", token);
          context.commit("ROLES_UPDATE", roles);
          context.commit("PERMISSIONS_UPDATE", permissions);
          resolve(response);
        })
        .catch((error) => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("roles");
          localStorage.removeItem("permissions");
          reject(error);
        });
    });
  },
  logout: (context) => {
    return new Promise((resolve) => {
      context.commit("USER_UPDATE", null);
      context.commit("TOKEN_UPDATE", null);
      context.commit("ROLES_UPDATE", null);
      context.commit("PERMISSIONS_UPDATE", null);

      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("roles");
      localStorage.removeItem("permissions");

      delete axios.defaults.headers.Authorization;

      resolve();
    });
  },
  updateUserProfile: (context, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: context.rootGetters.baseUrl + "auth/profile",
        data: {
          ...(payload.first_visit_date && {
            first_visit_date: LuxonDateTime.fromISO(
              payload.first_visit_date
            ).toFormat("yyyy-LL-dd"),
          }),
          id_card_number: payload.id_card_number,
          fullname: payload.fullname,
          date_of_birth: payload.date_of_birth,
          gender: payload.gender,
          religion: payload.religion,
          education: payload.education,
          profession: payload.profession,
          address: payload.address,
          marital_status: payload.marital_status,
          blood_type: payload.blood_type,
          department_id: payload.department_id,
          phone: payload.phone,
        },
      })
        .then((response) => {
          const user = JSON.stringify(response.data.data);

          localStorage.setItem("user", user);

          context.commit("USER_UPDATE", user);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateUserPassword: (context, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: context.rootGetters.baseUrl + "auth/password",
        data: {
          old_password: payload.oldPassword,
          new_password: payload.newPassword,
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetPassword: (context, user_id) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: context.rootGetters.baseUrl + "auth/reset-password",
        data: { user_id: user_id },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateUserEmail: (context, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: context.rootGetters.baseUrl + "auth/email",
        data: {
          email: payload.email,
        },
      })
        .then((response) => {
          const user = JSON.stringify(response.data.data);

          localStorage.setItem("user", user);

          context.commit("USER_UPDATE", user);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  USER_UPDATE: (state, user) => {
    state.user = user;
  },
  TOKEN_UPDATE: (state, token) => {
    state.token = token;
  },
  ROLES_UPDATE: (state, roles) => {
    state.roles = roles;
  },
  PERMISSIONS_UPDATE: (state, permissions) => {
    state.permissions = permissions;
  },
};

const getters = {
  user: (state) => (state.user ? JSON.parse(state.user) : null),
  token: (state) => state.token,
  roles: (state) => (state.roles ? JSON.parse(state.roles) : []),
  permissions: (state) =>
    state.permissions ? JSON.parse(state.permissions) : [],
  loggedUser: (state, getters) => {
    if (!getters.user) return null;

    return {
      ...getters.user,
      roles: getters.roles,
      permissions: getters.permissions,
    };
  },
  completedRegistration: (state, getters) => {
    const user = getters.user;
    if (!user) return false;

    const fields = [
      "id_card_number",
      "date_of_birth",
      "address",
      "education",
      "profession",
      "department_id",
    ];

    for (const f of fields) {
      if (!user[f]) return false;
    }

    return true;
  },
  isOfficialEmail: (state, getters) => {
    const user = getters.user;
    return user && user.email.endsWith("ugm.ac.id");
  },
};

export default {
  state: state,
  getters,
  actions,
  mutations,
};
